/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentBusinessEntitySelectPicker: "shipment-business-entity-select-picker",
  shipmentBusinessEntitySelectSearch: "shipment-business-entity-select-search",
} as const;
